module.exports = __webpack_public_path__ + "img/hipercard.3cb26221.png";